<template>
  <!-- 社内メニュー(splitterあり)とメインコンテンツ(splitterなし)を切り替えるnavigator -->
  <div>
    <v-ons-navigator
      :page-stack="pageStack"
      :options="options"
    />

    <load-progress />
  </div>
</template>

<script>
import loadProgress from '@/components/partials/loading.vue';
import mapSplitter from './map/splitter.vue';

export default {
  components: { loadProgress },
  computed: {
    pageStack: ({ $store }) => $store.state.appNavigator.stack,
    options: ({ $store }) => $store.state.appNavigator.options,
  },
  beforeCreate() {
    this.$store.commit('appNavigator/push', mapSplitter);
  },
};
</script>



// WEBPACK FOOTER //
// app_navigator.vue?d8a998d4